import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '../../../node_modules/angularfire2/database';
import { UserProvider } from '../user/user';
import { ThenableReference } from '../../../node_modules/@firebase/database-types';

import { Observable } from 'rxjs/Observable';
import "rxjs/add/operator/catch"
import { combineLatest } from 'rxjs/observable/combineLatest';
import { Stream } from '../../models/Stream';

@Injectable()
export class StreamProvider {

    allStreams: Observable<Stream[]>;

    constructor(
        private db: AngularFireDatabase,
        private user: UserProvider,
    ) {
        this.allStreams = this.getallStreamsObservable().shareReplay(1);
    }

    private getallStreamsObservable(): Observable<Stream[]> {
        let path = `streams`;

        return combineLatest(this.user.hasAccess(), this.user.isAdmin()).switchMap(access => {
            let hasAccess = access[0];
            let isAdmin = access[1];
            if (!(hasAccess || isAdmin)) return Observable.of([]);
            return this.db.list<Stream>(path, ref => ref.orderByChild('timestamp'))
                .snapshotChanges()
                .map(snapshot => {
                    let streams = [];
                    for (let snap of snapshot) {
                        const stream: Stream = snap.payload.val();
                        stream.key = snap.key;
                        streams.push(stream)
                        // console.log(liveSignal.key);
                    }
                    return streams.reverse();
                }).catch((error, caught) => {
                    console.log(error);
                    return Observable.of([]);
                })
        })
    }

    public getAllStreams(): Observable<Stream[]> {
        return this.allStreams;
    }

    public addStream(stream: Stream): ThenableReference {
        let path = 'streams';
        return this.db.database.ref(path).push(stream);
    }

    public editStream(stream: Stream): Promise<void> {
        if (!stream.key) return;
        let path = `streams/${stream.key}`;

        return this.db.database.ref(path).update(stream);
    }

    public removeStream(stream: Stream): Promise<void> {
        if (!stream.key) return;
        let path = `streams/${stream.key}`
        return this.db.database.ref(path).remove();
    }

    public getStreamById(id: string): Promise<Stream> {
        return this.allStreams.first().toPromise()
            .then(streams => {
                for (let stream of streams) {
                    if (stream.key == id) return stream;
                }
                return null;
            })
            .catch(error => { return null });
    }
}



// WEBPACK FOOTER //
// ./src/providers/stream/stream.ts